import Oidc from 'oidc-client'

var mgr = new Oidc.UserManager({
  authority: process.env.VUE_APP_IDENTITYSRV_AUTHORITY,
  client_id: 'VueClient',
  redirect_uri: process.env.VUE_APP_IDENTITYSRV_REDIRECT_URI,
  response_type: 'id_token token',
  scope: 'openid profile coreApi roles communicationsHub',
  post_logout_redirect_uri: process.env.VUE_APP_IDENTITYSRV_LOGOUT_URI,
  userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  silent_redirect_uri: process.env.VUE_APP_IDENTITYSRV_SILENT_REDIRECT_URI,
  accessTokenExpiringNotificationTime: 10,
})

Oidc.Log.logger = console
Oidc.Log.level = Oidc.Log.INFO

mgr.events.addAccessTokenExpiring(function () {
  console.log('AccessToken Expiring：', arguments);
});

mgr.events.addSilentRenewError(function () {
  console.error('Silent Renew Error：', arguments);
});

export default mgr
